<!-- This is vue3 Text Us form chat related is not yet converted handled only text widget flow its needed for contact us -->

<template>
  <div>
    <a v-if="enableStrolidWidget" ref="strolid-button" class="cursor-pointer" />
    <div v-else>
      <div
        v-if="opentextus && showChat && (isMobile || isIpadScreen)"
        :class="{ mobileChatModal: isMobile }"
      >
        <div class="chat-text-modal">
          <div id="chatTextModal" class="modal" :style="{ display: modalShow ? 'block' : 'none' }">
            <div class="modal-dialog">
              <div class="modal-content">
                <div
                  class="text-right close-chat-modal"
                  :class="{ is_tablet_device: isIpadScreen }"
                >
                  <a
                    href=""
                    class="no-hover no-hover-color color-black"
                    @click.prevent="oncloseclick()"
                  >
                    <em :style="{ color: primaryColor }" class="primaryicon-times" />
                    <span class="d-none">&nbsp;</span>
                  </a>
                </div>
                <chat-widget />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <Modal
          id="textus"
          ref="textusRef"
          v-model="modalShow"
          class="textusform"
          title="Sales"
          hide-footer
          hide-header
        >
          <div class="text-right">
            <a href="" class="no-hover no-hover-color color-black" @click.prevent="oncloseclick()"
              ><em class="primaryicon-times"
            /></a>
          </div>
          <textus-form
            :refer-from="referFrom"
            :openserviceprop="openservice"
            :opentransactprop="opentransact"
            :opensalesprop="opensales"
          />
        </Modal>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "../../Shared/Modal/Modal.vue";
import TextusForm from "../../../Components/ChatWidget/TextusForm/TextusForm.vue";

import eventBus from "../../../Services/EmitterService/EmitterService";

import ShiftDigitalContainer from "../../../Events/ShiftDigital/ShiftDigitalContainer";

import { SET_OPEN_TVM_NAVIGATE_TILE } from "../../../../../store/StoreConstants/CommonSettingsConstants";
import ChatWidget from "../../ChatWidget/ChatWidget/ChatWidget.vue";
import { mapWritableState } from "pinia";
import { useCommonSettingsStore } from "../../../store/CommonSettingsStore/CommonSettingsStore";

export default {
  components: {
    Modal,
    "textus-form": TextusForm,
    "chat-widget": ChatWidget,
  },
  props: {
    referFrom: {
      type: String,
      required: false,
      default: "",
    },
    opentextus: {
      type: Boolean,
      required: false,
      Default: false,
    },
    openservice: {
      type: Boolean,
      required: false,
      default: false,
    },
    opensales: {
      type: Boolean,
      required: false,
      default: false,
    },
    opentransact: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      modalShow: false,
      integrateWithText: window.integrateWithText,
      enableStrolidWidget: window.enableStrolidWidget,
      showText: window.isTextUsEnabled,
      showChat: window.isGoogleChatEnabled,
      isMobile: window.ismobile,
      isIpadScreen: window.istablet,
      primaryColor: window.primaryColor,
    };
  },
  watch: {
    modalShow() {
      if (this.modalShow === false) {
        this.$emit("hidemodal", this.modalShow);
        eventBus.$emit("showShopperWizard", { contact: "dsdsd" });
      }
    },
  },
  mounted() {
    // this.$root.$on("closeTextUsPopup", () => {
    //   if (this.$refs.textusRef && typeof this.$refs.textusRef.hide === "function") {
    //     this.$refs.textusRef.hide();
    //   }
    // });
    this.fireFordShiftDigitalOnMounted();
    logGoogleBingEvent("Text App", "button_click", " Start", 1, "Text App Click  ");
    if (this.enableStrolidWidget) {
      this.$refs["strolid-button"].className = "strolid-sms-link";
      this.$refs["strolid-button"].click();
      this.$emit("hidemodal", this.modalShow);
      eventBus.$emit("showShopperWizard", { contact: "dsdsd" });
    } else {
      this.$refs?.textusRef?.show?.();
      if (this.showChat) {
        this.modalShow = true;
      }
      if (document.querySelector("#chatTextModal")) {
        sessionStorage.setItem("chatTextModal", true);
      }
    }
    if (this.showChat) {
      window.addEventListener("tvmLoadPopUp", (event) => {
        this.modalShow = event?.detail;
        this.$root.$emit("close");
      });
    }
  },
  computed: {
    ...mapWritableState(useCommonSettingsStore, ["tvmNavigateTileSettings"]),
  },
  methods: {
    oncloseclick() {
      let shiftDigitalEvent = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigitalEvent && typeof shiftDigitalEvent.chatClosedsdEvent === "function") {
        shiftDigitalEvent.chatClosedsdEvent();
      }
      this.tvmNavigateTileSettings = {};

      this.modalShow = false;
      this.$emit("hidemodal", this.modalShow);
      document.querySelector("html").style.overflow = "auto";
      sessionStorage.removeItem("chatTextModal");
    },
    fireFordShiftDigitalOnMounted() {
      let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigital && typeof shiftDigital.newSpecialsTextUsFormOnLoad === "function") {
        let referFrom =
          this.referFrom && this.referFrom === "preowned" ? "pre-owned" : this.referFrom;
        if (this.referFrom) {
          setTimeout(() => {
            shiftDigital.newSpecialsTextUsFormOnLoad(referFrom);
          }, 3000);
        }
      }
    },
  },
};
</script>
<style scoped>
.text-us-title {
  left: 15px;
}

.textusform .modal-dialog {
  margin-top: 90px;
}

@media (max-width: 780px) {
  .textusform .modal-dialog {
    margin-top: 100px;
  }
}

@media (max-width: 340px) {
  .textusform .modal-dialog {
    margin-top: 90px !important;
  }
}

.chat-text-modal::v-deep .modal-body {
  padding: 0px !important;
}

.mobileChatModal .chat-text-modal::v-deep .modal {
  bottom: 0 !important;
  top: inherit !important;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.15) !important;
}

.mobileChatModal .chat-text-modal::v-deep .modal-dialog {
  margin: 0 !important;
}

.mobileChatModal .chat-text-modal::v-deep .modal-backdrop {
  background: transparent !important;
  opacity: 1 !important;
}

.mobileChatModal .chat-text-modal::v-deep .modal-backdrop.show {
  background: transparent !important;
  opacity: 1 !important;
}

.mobileChatModal .chat-text-modal::v-deep .modal-open .modal {
  overflow: hidden !important;
}

.close-chat-modal {
  position: absolute;
  right: 15px;
  z-index: 99;
  font-size: 11px;
  top: 10px;
  color: #cdcdcd;
  background: #fff;
  width: 25px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-chat-modal .primaryicon-times {
  font-size: 11px !important;
}

.close-chat-modal em {
  color: #cdcdcd;
}

.is_tablet_device.close-chat-modal {
  top: 21px !important;
}

.chat-text-modal::v-deep .modal {
  z-index: 99999;
}
</style>
